import { render, staticRenderFns } from "./charge-form.vue?vue&type=template&id=36aa9797&"
import script from "./charge-form.vue?vue&type=script&lang=js&"
export * from "./charge-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports